import { UserPermissions } from '../../../../../baseComponents/CreateRoutering/types'
import { ITLayoutTableModalOpen } from '../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/types'
import { InputTableLayoutData, InputTableURLsTable, OrderHeaderURLs, SetCompleteDataTy } from '../../../../../baseComponents/TwinTable/InputTableLayout/types'
import { BuildedOrder } from '../../../../../baseComponents/TwinTable/types'
import { TwinDictionary } from '../../../../../utils/globals/dictionary'
import { OnChangeOrderAddProduct } from '../../OrderLayout/OrderTable/TableComponents/Inputs/OrderSearchProductInput/types'
import ModalComplexProductOrder from '../../OrderLayout/OrderTable/TableComponents/ModalsOrderTable/ModalComplexProductOrder'
import ModalDeleteLineOrder from '../../OrderLayout/OrderTable/TableComponents/ModalsOrderTable/ModalDeleteLineOrder'
import ModalEditableTextProductOrder from '../../OrderLayout/OrderTable/TableComponents/ModalsOrderTable/ModalEditableTextProductOrder'
import ModalComplementProductOrder from '../../OrderLayout/OrderTable/TableComponents/ModalsOrderTable/ModalEditAddonProductOrder'
import ModalEditProductOrder from '../../OrderLayout/OrderTable/TableComponents/ModalsOrderTable/ModalEditProductOrder'
import ModalPriceProductOrder from '../../OrderLayout/OrderTable/TableComponents/ModalsOrderTable/ModalPriceProductOrder'
import ModalSyncProductPriceOrder from '../../OrderLayout/OrderTable/TableComponents/ModalsOrderTable/ModalSyncProductPriceOrder'
import ModalWarehouseProductOrder from '../../OrderLayout/OrderTable/TableComponents/ModalsOrderTable/ModalWarehouseProductOrder'
import ModalPrintSingleTagSellConnect from './ModalPrintSingleTagSell'
import ModalUniqueNumberProductOrderSell from './ModalUniqueNumberProductOrderSell'
import ModalWorkSheetStatusOrderProduct from './ModalWorkSheetStatusOrderProduct'
import './modalsOrderSellLayout.sass'
import ModalAddDiscountOrder from '../../OrderLayout/OrderTotal/FooterOrderTotal/Components/ModalFinancialRowsOrder/ModalAddDiscountOrder'
import ModalAddRechargesOrder from '../../OrderLayout/OrderTotal/FooterOrderTotal/Components/ModalFinancialRowsOrder/ModalAddRechargeOrder'
import ModalConfigShippingSellOrder from './ModalConfigShippingSellOrder'
import ModalOrderPaymentMethodConnect from '../../OrderLayout/OrderTable/TableComponents/ModalsOrderTable/ModalOrderPaymentMethod'
import { FooterTotalsResult } from '@teinor/erp/types/company/order/general'
import ModalOrderPaymentMethodSimpleConnect from '../../OrderLayout/OrderTable/TableComponents/ModalsOrderTable/ModalOrderPaymentMethodSimple'
import ModalCreateProductConnect from '../../../../../app/erp/screens/Logistic/ProductsParent/Products/ModalCreateProduct'
import ModalCreateAddonConnect from '../../../../../app/erp/screens/Logistic/ProductsParent/Addons/ModalCreateAddon'

interface ModalsOrderSellLayoutProps {
    openModal: ITLayoutTableModalOpen
    setOpenModal: React.Dispatch<React.SetStateAction<ITLayoutTableModalOpen>>
    setCompleteData: SetCompleteDataTy
    onChangeAdd: OnChangeOrderAddProduct
    onChangeUpdate: () => void
    deleteLine: (id: number) => void
    inputTableURLs: InputTableURLsTable
    userPermissions: UserPermissions
    headerData: TwinDictionary
    getCompleteData: (order?: BuildedOrder) => Promise<void>
    onChangeFetch: (rowIndex: number, keyValue: string, value: string) => Promise<void>
    completeData: InputTableLayoutData
    totalsOrderTableData: FooterTotalsResult
    isReadOnly?: boolean
    orderHeaderURLs: OrderHeaderURLs
    modelId: string
    myOrderId?: number
}

const ModalsOrderSellLayout: React.FC<ModalsOrderSellLayoutProps> = ({ openModal, onChangeAdd, onChangeUpdate, onChangeFetch, deleteLine, setOpenModal, ...rest }) => {
    const typeDict: any = {
        editProduct: { component: ModalEditProductOrder, onSubmit: onChangeUpdate },
        priceProduct: { component: ModalPriceProductOrder, onSubmit: onChangeUpdate },
        deleteLine: { component: ModalDeleteLineOrder, onSubmit: () => deleteLine(openModal?.allRowData.id) },
        complexProduct: { component: ModalComplexProductOrder},
        editableText: { component: ModalEditableTextProductOrder, onSubmit: (value: any) => onChangeFetch(openModal?.allRowData.absoluteIndex || openModal?.allRowData.rowIndex, openModal?.allRowData.dataKey, value) },
        editAddonProduct: { component: ModalComplementProductOrder, onSubmit: onChangeUpdate },
        uniqueNumber: { component: ModalUniqueNumberProductOrderSell, onSubmit: onChangeUpdate },
        warehouses: { component: ModalWarehouseProductOrder },
        syncPrice: { component: ModalSyncProductPriceOrder, onSubmit: rest.getCompleteData },
        workSheetStatus: { component: ModalWorkSheetStatusOrderProduct },
        printTags: { component: ModalPrintSingleTagSellConnect },
        configShipping: { component: ModalConfigShippingSellOrder },
        configPaymentMethod: { component: ModalOrderPaymentMethodConnect },
        configPaymentMethodSimple: { component: ModalOrderPaymentMethodSimpleConnect },
        addDiscount: { component: ModalAddDiscountOrder },
        addRecharge: { component: ModalAddRechargesOrder },
        createProduct: { component: ModalCreateProductConnect, onSubmit: openModal?.allRowData?.onSubmit },
        createComplement: { component: ModalCreateAddonConnect, onSubmit: openModal?.allRowData?.onSubmit }
    }
    if (openModal?.type && openModal.type in typeDict) {
        const element = typeDict[openModal.type]
        const Component = element.component
        const onSubmit = element.onSubmit
        return <Component allRowData={openModal.allRowData} {...rest} orderURLs={rest.inputTableURLs} onSubmit={onSubmit} setOpened={() => setOpenModal(null)} tableData={rest.completeData.tableData} navigateToProduct={false} />
    }
    return null
}

export default ModalsOrderSellLayout